import React from 'react';
import {useIntl} from "react-intl";
import styles from './styles.module.scss';

const FiltersLabel = ({textContent}) => {
  const intl = useIntl();
  const labelFilters = intl.formatMessage({
    id: 'invoices-page-label-filters',
    defaultMessage: 'Search',
  });

  return (
    <div className={styles.filtersLabel}>
      {textContent ? textContent : labelFilters}
    </div>
  );
}

export default FiltersLabel;
